import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { DigitShortcutCurrency } from '../types/currency';
import { CurrencyDigitShortcutPipeInput, DigitShortcuts } from './pipes';

@Pipe({
  name: 'currencyDigitShortcut',
  standalone: false
})
export class CurrencyDigitShortcutPipe implements PipeTransform {

  public constructor(
    private translateService: TranslateService,
  ) { }

  public transform(value: number, options?: CurrencyDigitShortcutPipeInput, hideValue?: boolean): string {
    if (options?.units) {
      const unitsSuffix = this.assignUnitToValue(value, options.units);

      return hideValue ? unitsSuffix : value + ' ' + unitsSuffix;
    }

    if (options?.digitShortcuts) {
      return this.formatValueByThousands(value, options.digitShortcuts);
    }

    return value + '';
  }

  private formatValueByThousands(value: number, digitShortcuts: DigitShortcuts): string {
    if (value >= 100 && value < 1000 && digitShortcuts.hundreds) {
      const trimmedValue = value/100;
      return trimmedValue + ' ' + this.translateService.instant(digitShortcuts.hundreds);
    } else if (value >= 1000 && value < 1000000 && digitShortcuts.thousands) {
      const trimmedValue = value/1000;
      return trimmedValue + ' ' + this.translateService.instant(digitShortcuts.thousands);
    } else if (value >= 1000000 && value < 1000000000 && digitShortcuts.millions) {
      const trimmedValue = value/1000000;
      return trimmedValue + ' ' + this.translateService.instant(digitShortcuts.millions);
    } else if (value >= 1000000000 && digitShortcuts.billions) {
      const trimmedValue = value/1000000000;
      return trimmedValue + ' ' + this.translateService.instant(digitShortcuts.billions);
    } else {
      return value + digitShortcuts.default;
    }
  }

  private assignUnitToValue(value: number, units: DigitShortcutCurrency): string {
    if (value === 1 && units.first) {
      return this.translateService.instant(units.first);
    } else if (value >= 2 && units.secondAndOn && value < 5) {
      return this.translateService.instant(units.secondAndOn);
    } else if (value >= 5 && units.fifthAndOn) {
      return this.translateService.instant(units.fifthAndOn);
    } else {
      return units.default ? this.translateService.instant(units.default) : '';
    }
  }
}
